import type React from 'react';
import IconButton from '@mui/material/IconButton';
import { tooltipClasses } from '@mui/material/Tooltip';
import { StyledInfoIcon } from './StyledInfoIcon';
import { styled as muiStyled } from '@mui/material/styles';
import { ResponsiveTooltip } from '@/components/common/responsive-tooltip';

export const MorphingInfo: React.FC = () => (
  <ResponsiveTooltip.Layout
    render={(isTooltipOpen, onTouchStart): JSX.Element => (
      <CustomWidthTooltip
        arrow
        title={
          <span style={{ fontSize: '1.2em' }}>
            For visualization purposes, the upper part of the device can be reshaped to the angulation of the aorta.
            Please note that this reshaping may not be physically accurate. The bottom part, in the aortic root, remains
            in the nominal state as no true simulation is performed. Measurements provided are based on the nominal
            state of the device and the preop state of the anatomy.
          </span>
        }
        placement="left"
        open={isTooltipOpen}
      >
        <IconButton size="large" onTouchStart={onTouchStart}>
          <StyledInfoIcon />
        </IconButton>
      </CustomWidthTooltip>
    )}
  />
);

export const CustomWidthTooltip = muiStyled(ResponsiveTooltip.Tooltip)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    padding: '1em',
    lineHeight: '1.8em'
  }
}));
